module.exports = __webpack_public_path__ + "static/media/recover-pass-img.6b89b1e7.svg";